import { IHttpClient } from '@/core/services/http'
import { SendMessageDto } from '../types/request-dto/send-message.dto'

export function createSendContactMessageUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function (input: SendMessageDto) {
    try {
      await httpClient.version('v1').post('/website/customer/contact', input)
    } catch (_) {
      return ''
    }
  }
}
